import { put } from 'redux-saga/effects'
import { IPcr } from '../../../../pcr/store/pcr.types'
import { setBurns } from '../store/burns.actions'

export function* getBurns(pcrDoc: IPcr) {
  const burnsData = pcrDoc.additionalAssessment?.burns

  if (burnsData && Object.keys(burnsData).length !== 0) {
    yield put(setBurns(burnsData))
  }
}
